import "./App.css";
import "@progress/kendo-theme-default/dist/all.css";
import React from "react";
// Moment Date Picker
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Router from './routes';
// theme
import  ThemeProvider   from './theme/index';
// components
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
export default function App() {

  return (
  
    <ThemeProvider>
    <ToastContainer position="top-left"/>
      <ThemeColorPresets>
      <LocalizationProvider dateAdapter={AdapterMoment}>
      
        <RtlLayout>
          <MotionLazyContainer>
            <ProgressBarStyle />
            <Settings />
            <ScrollToTop />
            {/* <routePages></routePages> */}{console.log("API URL: ", process.env.REACT_APP_API_URL)}
            <Router />
          </MotionLazyContainer>
        </RtlLayout>
        </LocalizationProvider>
      </ThemeColorPresets>
    </ThemeProvider>
 
  );
}

